import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { ButtonComponent } from '../../buttons/button/button.component';
import { DialogHeaderComponent } from '../dialog-header/dialog-header.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonType } from '../../enum/button-type.enum';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'lib-list-confirmation-dialog',
  imports: [ButtonComponent, DialogHeaderComponent, ReactiveFormsModule],
  templateUrl: './list-confirmation-dialog.component.html',
  styleUrl: './list-confirmation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListConfirmationDialogComponent {
  private dialogRef = inject(MatDialogRef<ListConfirmationDialogComponent>);

  public config = signal<ListConfirmationDialogConfig | null>(null);

  protected readonly ButtonType = ButtonType;

  primaryButtonClicked() {
    this.dialogRef.close(true);
  }

  secondaryButtonClicked() {
    this.dialogRef.close(false);
  }

  closeClicked() {
    this.dialogRef.close(false);
  }
}

export interface ListConfirmationDialogConfig {
  title: string;
  messageAboveList: string;
  messageBelowList?: string;
  list: string[];
  primaryButtonText: string;
  secondaryButtonText: string;
}
